import { useTranslation } from 'react-i18next';

interface SurveyStatusBadgeProps {
  status: string;
}

export function SurveyStatusBadge({ status }: SurveyStatusBadgeProps) {
  const { t } = useTranslation();
  const labels: Record<string, string> = {
    active:           t('admin.statusActive'),
    paused:           t('admin.statusPaused'),
    inactive:         t('admin.statusInactive'),
    pending_approval: t('admin.statusPending'),
  };
  return (
    <span className={`adm-status-badge adm-status-${status}`}>
      {labels[status] ?? status}
    </span>
  );
}
